import $ from 'jquery';

export function update(data, $scope = $(document)) {
    $scope.find('[data-bind]').each(function () {
        var $this = $(this);
        var key = $this.data('bind');
        var split = key.split('.');
        var i;
        var clonedData = $.extend(true, {}, data);
        var localKey;
        var maxLevel = split.length - 1;

        for (i in split) {
            /* istanbul ignore else */
            if (split.hasOwnProperty(i)) {
                localKey = split[i];

                if (typeof clonedData[localKey] !== 'undefined') {
                    if (i === maxLevel) {
                        $this.html(clonedData[localKey]);
                    } else {
                        clonedData = clonedData[localKey];
                    }
                }
            }
        }
    });
}



/** WEBPACK FOOTER **
 ** ./legacy/home24/helpers/data-bind.js
 **/